import styled from 'styled-components';
import { selectionShadowFor } from './PlacementBox.utils.ts';

// Drag/resize wrapper; the preview draws the border, this layer only adds the
// selection ring and a cursor: move affordance.
export const Shell = styled.div<{
	$selected: boolean;
	$overlapping: boolean;
	$dropBlocked: boolean;
}>`
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	cursor: move;
	user-select: none;
	border-radius: 6px;
	opacity: ${({ $dropBlocked }) => ($dropBlocked ? 0.55 : 1)};
	box-shadow: ${({ $selected, $overlapping }) => selectionShadowFor($selected, $overlapping)};
`;

export const A11yLabel = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	overflow: hidden;
	clip: rect(0 0 0 0);
	white-space: nowrap;
`;
